module.exports = __webpack_public_path__ + "img/ic-menu-inactive.16788278.svg";